<template>
  <div class="input-field">
    <label :for="name"></label>
    <input class="input-with-btn" :name="name" :id="name" :type="type" :value="getPromoUrl" readonly
           @focus="select"/>
    <button type='submit' class="btn-flat btn-copy" @click="copyPromoUrl()">
      <img src="../../assets/copy-icon.svg">
    </button>
  </div>
</template>

<script>
import Materialize from 'materialize-css'
import { mapGetters } from 'vuex'
import { copyToClipboard } from '@/services/helper'
export default {
  props: ['type', 'name', 'label'],
  created () {
    this.$store.dispatch('promoCode', 'get')
  },
  computed: {
    // mix the getters into the computed object
    ...mapGetters([
      'getPromoUrl'
    ])
  },
  methods: {
    select (e) {
      e.target.select()
    },
    copyPromoUrl () {
      const text = this.getPromoUrl
      if (text && copyToClipboard(text)) {
        Materialize.toast('Skopiowano: ' + text, 2000)
      } else {
        Materialize.toast('Nie udało się skopiować linku', 1000)
      }
    }
  }
}
</script>

<style lang="scss" src="./input.scss"></style>



// WEBPACK FOOTER //
// promoUrl.vue?074bac86